'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BATCH_ACTION_TYPE = exports.enableReducerBatching = exports.bulkingMiddleware = undefined;

var _lodash = require('lodash');

var _reduxBatchMiddleware = require('redux-batch-middleware');

var createDefaultIsBulkableAction = function createDefaultIsBulkableAction(_ref) {
    var _ref$bulkActionTypes = _ref.bulkActionTypes,
        bulkActionTypes = _ref$bulkActionTypes === undefined ? [] : _ref$bulkActionTypes;
    return function (action) {
        return (0, _lodash.includes)(bulkActionTypes, action.type);
    };
};

/**
 * Must be used in conjunction with redux-batch-middleware: https://github.com/mrydengren/redux-batch-middleware
 *
 * This allows specific actions to be debounced and batched together so they are dispatched as a single state update.
 */
var bulkingMiddleware = exports.bulkingMiddleware = function bulkingMiddleware() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function (store) {
        return function (next) {
            var _config$debounceWait = config.debounceWait,
                debounceWait = _config$debounceWait === undefined ? 0 : _config$debounceWait,
                debounceOptions = config.debounceOptions;

            var isBulkableAction = config.isBulkableAction || createDefaultIsBulkableAction(config);
            var batchMiddleware = (0, _reduxBatchMiddleware.batch)(store)(next);

            var bulkAction = [];

            var addToBulkAction = function addToBulkAction(action) {
                bulkAction.push(action);
            };

            var dispatchBulkAction = function dispatchBulkAction() {
                var bulkActionToDispatch = bulkAction;
                bulkAction = [];
                return batchMiddleware(bulkActionToDispatch);
            };

            var debouncedBulkActionDispatch = (0, _lodash.debounce)(dispatchBulkAction, debounceWait, debounceOptions);

            return function (action) {
                if (!isBulkableAction(action)) return batchMiddleware(action);

                addToBulkAction(action);
                return debouncedBulkActionDispatch();
            };
        };
    };
};

var enableReducerBatching = exports.enableReducerBatching = _reduxBatchMiddleware.batching;

var BATCH_ACTION_TYPE = exports.BATCH_ACTION_TYPE = _reduxBatchMiddleware.type;


//////////////////
// WEBPACK FOOTER
// ./src/client/store/reduxBulkingMiddleware.js
// module id = 307
// module chunks = 0